var map = {
	".": 12,
	"./": 12,
	"./Card": 22,
	"./Card.js": 22,
	"./Footer": 23,
	"./Footer.js": 23,
	"./Main": 19,
	"./Main.css": 31,
	"./Main.js": 19,
	"./Overlay": 13,
	"./Overlay.js": 13,
	"./OverlayBottom": 20,
	"./OverlayBottom.js": 20,
	"./fonts/belisa_plumilla-webfont.woff": 136,
	"./fonts/belisa_plumilla-webfont.woff2": 137,
	"./fonts/belisa_plumilla.ttf": 138,
	"./fonts/fonts.css": 27,
	"./food": 1,
	"./food.json": 1,
	"./images/bg/1.jpg": 139,
	"./images/bg/2.png": 140,
	"./images/bg/3.png": 141,
	"./images/bg/4.png": 142,
	"./images/bg/5.jpg": 28,
	"./images/crockpot/amberosia.png": 143,
	"./images/crockpot/asparagazpacho.png": 144,
	"./images/crockpot/asparagussoup.png": 145,
	"./images/crockpot/baconandeggs.png": 146,
	"./images/crockpot/bananapop.png": 147,
	"./images/crockpot/bananashake.png": 148,
	"./images/crockpot/barnaclelinguine.png": 149,
	"./images/crockpot/barnaclenigiri.png": 150,
	"./images/crockpot/barnaclepita.png": 151,
	"./images/crockpot/beefalotreats.png": 152,
	"./images/crockpot/beefygreens.png": 153,
	"./images/crockpot/bonebouillon.png": 154,
	"./images/crockpot/breakfastskillet.png": 155,
	"./images/crockpot/bunnystew.png": 156,
	"./images/crockpot/buttermuffin.png": 157,
	"./images/crockpot/californiaroll.png": 158,
	"./images/crockpot/ceviche.png": 159,
	"./images/crockpot/creamypotatopuree.png": 160,
	"./images/crockpot/dragonpie.png": 161,
	"./images/crockpot/fancyspiralledtubers.png": 162,
	"./images/crockpot/figatoni.png": 163,
	"./images/crockpot/figgyfrogwich.png": 164,
	"./images/crockpot/figkabab.png": 165,
	"./images/crockpot/figstuffedtrunk.png": 166,
	"./images/crockpot/fishcordonbleu.png": 167,
	"./images/crockpot/fishsticks.png": 168,
	"./images/crockpot/fishtacos.png": 169,
	"./images/crockpot/fistfullofjam.png": 170,
	"./images/crockpot/flowersalad.png": 171,
	"./images/crockpot/freshfruitcrepes.png": 172,
	"./images/crockpot/froggiebunwich.png": 173,
	"./images/crockpot/frozenbananadaiquiri.png": 174,
	"./images/crockpot/fruitmedley.png": 175,
	"./images/crockpot/glowberrymousse.png": 176,
	"./images/crockpot/grimgalette.png": 177,
	"./images/crockpot/guacamole.png": 178,
	"./images/crockpot/honeyham.png": 179,
	"./images/crockpot/honeynuggets.png": 180,
	"./images/crockpot/hotdragonchilisalad.png": 181,
	"./images/crockpot/icecream.png": 182,
	"./images/crockpot/jellybeans.png": 183,
	"./images/crockpot/jellysalad.png": 184,
	"./images/crockpot/kabobs.png": 185,
	"./images/crockpot/leafymeatloaf.png": 186,
	"./images/crockpot/lobsterbisque.png": 187,
	"./images/crockpot/lobsterdinner.png": 188,
	"./images/crockpot/mandrakesoup.png": 189,
	"./images/crockpot/meatballs.png": 190,
	"./images/crockpot/meatystew.png": 191,
	"./images/crockpot/melonsicle.png": 192,
	"./images/crockpot/milkmadehat.png": 193,
	"./images/crockpot/monsterlasagne.png": 194,
	"./images/crockpot/monstertartare.png": 195,
	"./images/crockpot/moqueca.png": 196,
	"./images/crockpot/mushycake.png": 197,
	"./images/crockpot/musselbouillabaise.png": 198,
	"./images/crockpot/pierogi.png": 199,
	"./images/crockpot/plainomelette.png": 200,
	"./images/crockpot/powdercake.png": 201,
	"./images/crockpot/puffedpotatosouffle.png": 202,
	"./images/crockpot/pumpkincookie.png": 203,
	"./images/crockpot/ratatouille.png": 204,
	"./images/crockpot/salsafresca.png": 205,
	"./images/crockpot/seafoodgumbo.png": 206,
	"./images/crockpot/soothingtea.png": 207,
	"./images/crockpot/spicychili.png": 208,
	"./images/crockpot/steamedtwigs.png": 209,
	"./images/crockpot/stuffedeggplant.png": 210,
	"./images/crockpot/stuffedfishheads.png": 211,
	"./images/crockpot/stuffednightcap.png": 212,
	"./images/crockpot/stuffedpepperpoppers.png": 213,
	"./images/crockpot/surfnturf.png": 214,
	"./images/crockpot/sweetpotatosouffle.png": 215,
	"./images/crockpot/taffy.png": 216,
	"./images/crockpot/tallscotcheggs.png": 217,
	"./images/crockpot/trailmix.png": 218,
	"./images/crockpot/turkeydinner.png": 219,
	"./images/crockpot/unagi.png": 220,
	"./images/crockpot/vegetablestinger.png": 221,
	"./images/crockpot/veggieburger.png": 222,
	"./images/crockpot/voltgoatchaudfroid.png": 223,
	"./images/crockpot/waffles.png": 224,
	"./images/crockpot/wetgoop.png": 225,
	"./images/icons/asterisk.png": 26,
	"./images/icons/crockpot.png": 29,
	"./images/icons/donot - OLD.png": 226,
	"./images/icons/donot.png": 18,
	"./images/icons/health.png": 14,
	"./images/icons/heart.png": 25,
	"./images/icons/hunger.png": 15,
	"./images/icons/rot.png": 17,
	"./images/icons/sanity.png": 16,
	"./images/ingredients/any.png": 55,
	"./images/ingredients/asparagus.png": 56,
	"./images/ingredients/banana.png": 57,
	"./images/ingredients/barnacle.png": 58,
	"./images/ingredients/berries.png": 59,
	"./images/ingredients/birchnut.png": 60,
	"./images/ingredients/bluecap.png": 61,
	"./images/ingredients/boneshards.png": 62,
	"./images/ingredients/butter.png": 63,
	"./images/ingredients/butterflywings.png": 64,
	"./images/ingredients/cactus.png": 65,
	"./images/ingredients/cactusflower.png": 66,
	"./images/ingredients/carrot.png": 67,
	"./images/ingredients/collecteddust.png": 68,
	"./images/ingredients/corn.png": 69,
	"./images/ingredients/dairy.png": 70,
	"./images/ingredients/dragonfruit.png": 71,
	"./images/ingredients/drumstick.png": 72,
	"./images/ingredients/durian.png": 73,
	"./images/ingredients/eel.png": 74,
	"./images/ingredients/egg.png": 75,
	"./images/ingredients/eggplant.png": 76,
	"./images/ingredients/electricmilk.png": 77,
	"./images/ingredients/fig.png": 78,
	"./images/ingredients/fishes.png": 79,
	"./images/ingredients/fishmeat.png": 80,
	"./images/ingredients/fishmorsel.png": 81,
	"./images/ingredients/forgetmelots.png": 82,
	"./images/ingredients/frame.png": 8,
	"./images/ingredients/freshwaterfish.png": 83,
	"./images/ingredients/froglegs.png": 84,
	"./images/ingredients/fruits.png": 85,
	"./images/ingredients/fruitsandveggies.png": 86,
	"./images/ingredients/garlic.png": 87,
	"./images/ingredients/glowberry.png": 88,
	"./images/ingredients/greencap.png": 89,
	"./images/ingredients/honey.png": 90,
	"./images/ingredients/ice.png": 91,
	"./images/ingredients/kelpfronds.png": 92,
	"./images/ingredients/koalefanttrunks.png": 93,
	"./images/ingredients/leafymeat.png": 94,
	"./images/ingredients/lesserglowberry.png": 95,
	"./images/ingredients/lichen.png": 96,
	"./images/ingredients/liveeel.png": 97,
	"./images/ingredients/mandrake.png": 98,
	"./images/ingredients/meat.png": 99,
	"./images/ingredients/meats.png": 100,
	"./images/ingredients/moleworm.png": 101,
	"./images/ingredients/monsterfoods.png": 102,
	"./images/ingredients/monstermeat.png": 103,
	"./images/ingredients/moonshroom.png": 104,
	"./images/ingredients/morsel.png": 105,
	"./images/ingredients/nakednostrils.png": 106,
	"./images/ingredients/nightmarefuel.png": 107,
	"./images/ingredients/onion.png": 108,
	"./images/ingredients/pepper.png": 109,
	"./images/ingredients/pomegranate.png": 110,
	"./images/ingredients/potato.png": 111,
	"./images/ingredients/pumpkin.png": 112,
	"./images/ingredients/redcap.png": 113,
	"./images/ingredients/roastedbirchnut.png": 114,
	"./images/ingredients/royaljelly.png": 115,
	"./images/ingredients/seaweed.png": 116,
	"./images/ingredients/sorted/dairy/butter.webp": 227,
	"./images/ingredients/sorted/dairy/electricmilk.webp": 228,
	"./images/ingredients/sorted/eggs/cookedegg.webp": 229,
	"./images/ingredients/sorted/eggs/egg.webp": 230,
	"./images/ingredients/sorted/eggs/friedtallbirdegg.webp": 231,
	"./images/ingredients/sorted/eggs/tallbirdegg.webp": 232,
	"./images/ingredients/sorted/fruit/berries.webp": 233,
	"./images/ingredients/sorted/fruit/cavebanana.webp": 234,
	"./images/ingredients/sorted/fruit/cookedcavebanana.webp": 235,
	"./images/ingredients/sorted/fruit/dragonfruit.webp": 236,
	"./images/ingredients/sorted/fruit/durian.webp": 237,
	"./images/ingredients/sorted/fruit/extrasmellydurian.webp": 238,
	"./images/ingredients/sorted/fruit/glowberry.webp": 239,
	"./images/ingredients/sorted/fruit/grilledwatermelon.webp": 240,
	"./images/ingredients/sorted/fruit/juicyberries.webp": 241,
	"./images/ingredients/sorted/fruit/lesserglowberry.webp": 242,
	"./images/ingredients/sorted/fruit/pomegranate.webp": 243,
	"./images/ingredients/sorted/fruit/prepareddragonfruit.webp": 244,
	"./images/ingredients/sorted/fruit/roastedberries.webp": 245,
	"./images/ingredients/sorted/fruit/roastedjuicyberries.webp": 246,
	"./images/ingredients/sorted/fruit/slicedpomegranate.webp": 247,
	"./images/ingredients/sorted/fruit/watermelon.webp": 248,
	"./images/ingredients/sorted/inedible/boneshards.webp": 249,
	"./images/ingredients/sorted/inedible/nightmarefuel.webp": 250,
	"./images/ingredients/sorted/inedible/twigs.webp": 251,
	"./images/ingredients/sorted/inedible/voltgoathorn.webp": 252,
	"./images/ingredients/sorted/meats/batiliskwing.webp": 253,
	"./images/ingredients/sorted/meats/cookedbatiliskwing.webp": 254,
	"./images/ingredients/sorted/meats/cookedeel.webp": 255,
	"./images/ingredients/sorted/meats/cookedfishmorsel.webp": 256,
	"./images/ingredients/sorted/meats/cookedfroglegs.webp": 257,
	"./images/ingredients/sorted/meats/cookedleafymeat.webp": 258,
	"./images/ingredients/sorted/meats/cookedmeat.webp": 259,
	"./images/ingredients/sorted/meats/cookedmonstermeat.webp": 260,
	"./images/ingredients/sorted/meats/cookedmorsel.webp": 261,
	"./images/ingredients/sorted/meats/deadwobster.webp": 262,
	"./images/ingredients/sorted/meats/deliciouswobster.webp": 263,
	"./images/ingredients/sorted/meats/drumstick.webp": 264,
	"./images/ingredients/sorted/meats/eel.webp": 265,
	"./images/ingredients/sorted/meats/fishmeat.webp": 266,
	"./images/ingredients/sorted/meats/fishmorsel.webp": 267,
	"./images/ingredients/sorted/meats/fishsteak.webp": 268,
	"./images/ingredients/sorted/meats/freshwaterfish.webp": 269,
	"./images/ingredients/sorted/meats/frieddrumstick.webp": 270,
	"./images/ingredients/sorted/meats/froglegs.webp": 271,
	"./images/ingredients/sorted/meats/jerky.webp": 272,
	"./images/ingredients/sorted/meats/koalefanttrunk.webp": 273,
	"./images/ingredients/sorted/meats/koalefanttrunksteak.webp": 274,
	"./images/ingredients/sorted/meats/leafymeat.webp": 275,
	"./images/ingredients/sorted/meats/liveeel.webp": 276,
	"./images/ingredients/sorted/meats/meat.webp": 277,
	"./images/ingredients/sorted/meats/moleworm.webp": 278,
	"./images/ingredients/sorted/meats/monsterjerky.webp": 279,
	"./images/ingredients/sorted/meats/monstermeat.webp": 280,
	"./images/ingredients/sorted/meats/morsel.webp": 281,
	"./images/ingredients/sorted/meats/rawfish.webp": 282,
	"./images/ingredients/sorted/meats/smalljerky.webp": 283,
	"./images/ingredients/sorted/meats/winterkoalefanttrunk.webp": 284,
	"./images/ingredients/sorted/meats/wobster.webp": 285,
	"./images/ingredients/sorted/sweetener/honey.webp": 286,
	"./images/ingredients/sorted/sweetener/honeycomb.webp": 287,
	"./images/ingredients/sorted/sweetener/royaljelly.webp": 288,
	"./images/ingredients/sorted/vegetable/Blue_Cap.webp": 289,
	"./images/ingredients/sorted/vegetable/Braised_Eggplant.webp": 290,
	"./images/ingredients/sorted/vegetable/Cactus_Flesh.webp": 291,
	"./images/ingredients/sorted/vegetable/Cactus_Flower.webp": 292,
	"./images/ingredients/sorted/vegetable/Carrot.webp": 293,
	"./images/ingredients/sorted/vegetable/Cooked_Blue_Cap.webp": 294,
	"./images/ingredients/sorted/vegetable/Cooked_Cactus_Flesh.webp": 295,
	"./images/ingredients/sorted/vegetable/Cooked_Green_Cap.webp": 296,
	"./images/ingredients/sorted/vegetable/Cooked_Kelp_Fronds.webp": 297,
	"./images/ingredients/sorted/vegetable/Cooked_Mandrake.webp": 298,
	"./images/ingredients/sorted/vegetable/Cooked_Red_Cap.webp": 299,
	"./images/ingredients/sorted/vegetable/Cooked_Stone_Fruit.webp": 300,
	"./images/ingredients/sorted/vegetable/Corn.webp": 301,
	"./images/ingredients/sorted/vegetable/Dried_Kelp_Fronds.webp": 302,
	"./images/ingredients/sorted/vegetable/Eggplant.webp": 303,
	"./images/ingredients/sorted/vegetable/Garlic.webp": 304,
	"./images/ingredients/sorted/vegetable/Green_Cap.webp": 305,
	"./images/ingredients/sorted/vegetable/Hot_Pumpkin.webp": 306,
	"./images/ingredients/sorted/vegetable/Kelp_Fronds.webp": 307,
	"./images/ingredients/sorted/vegetable/Lichen.webp": 308,
	"./images/ingredients/sorted/vegetable/Mandrake.webp": 309,
	"./images/ingredients/sorted/vegetable/Onion.webp": 310,
	"./images/ingredients/sorted/vegetable/Pepper.webp": 311,
	"./images/ingredients/sorted/vegetable/Popcorn.webp": 312,
	"./images/ingredients/sorted/vegetable/Potato.webp": 313,
	"./images/ingredients/sorted/vegetable/Pumpkin.webp": 314,
	"./images/ingredients/sorted/vegetable/Ripe_Stone_Fruit.webp": 315,
	"./images/ingredients/sorted/vegetable/Roast_Garlic.webp": 316,
	"./images/ingredients/sorted/vegetable/Roast_Onion.webp": 317,
	"./images/ingredients/sorted/vegetable/Roast_Potato.webp": 318,
	"./images/ingredients/sorted/vegetable/Roast_Toma_Root.webp": 319,
	"./images/ingredients/sorted/vegetable/Roasted_Carrot.webp": 320,
	"./images/ingredients/sorted/vegetable/Roasted_Pepper.webp": 321,
	"./images/ingredients/sorted/vegetable/Toma_Root.webp": 322,
	"./images/ingredients/sorted/vegetable/butterflywings.webp": 323,
	"./images/ingredients/sorted/vegetable/redcap.webp": 324,
	"./images/ingredients/sorted/vegetable/roastedbirchnut.webp": 325,
	"./images/ingredients/sorted/vegetable/stonefruit.webp": 326,
	"./images/ingredients/stonefruit.png": 117,
	"./images/ingredients/tallbirdegg.png": 118,
	"./images/ingredients/toma.png": 119,
	"./images/ingredients/twigs.png": 120,
	"./images/ingredients/vegetables.png": 121,
	"./images/ingredients/voltgoathorn.png": 122,
	"./images/ingredients/watermelon.png": 123,
	"./images/ingredients/wobster.png": 124,
	"./images/portraits/Maxwell_Portrait.png": 32,
	"./images/portraits/WX-78_Portrait.png": 33,
	"./images/portraits/Wagstaff_Portrait.png": 34,
	"./images/portraits/Walani_Portrait.png": 35,
	"./images/portraits/Walter_Portrait.png": 36,
	"./images/portraits/Wanda_Portrait.png": 37,
	"./images/portraits/Warly_Portrait.png": 21,
	"./images/portraits/Webber_Portrait.png": 38,
	"./images/portraits/Wendy_Portrait.png": 39,
	"./images/portraits/Wes_Portrait.png": 40,
	"./images/portraits/Wheeler_Portrait.png": 41,
	"./images/portraits/Wickerbottom_Portrait.png": 42,
	"./images/portraits/Wigfrid_Portrait.png": 43,
	"./images/portraits/Wilba_Portrait.png": 44,
	"./images/portraits/Wilbur_Portrait.png": 45,
	"./images/portraits/Willow_Portrait.png": 46,
	"./images/portraits/Wilson_Portrait.png": 47,
	"./images/portraits/Winona_Portrait.png": 48,
	"./images/portraits/Wolfgang_Portrait.png": 49,
	"./images/portraits/Woodie_Portrait.png": 50,
	"./images/portraits/Woodlegs_Portrait.png": 51,
	"./images/portraits/Wormwood_Portrait.png": 52,
	"./images/portraits/Wortox_Portrait.png": 53,
	"./images/portraits/Wurt_Portrait.png": 54,
	"./index": 12,
	"./index.js": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;